import { Tooltip } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useViewState } from 'hooks/ViewStateContext';
import React from 'react';
import AgentNetButton from '../button/AgentNetButton';

interface BottomAppBarProps {
  showPrimary?: boolean;
  omitPrimaryBorder?: boolean;
  cancelLabel?: string;
  primaryActionLabel?: string;
  primaryLabel?: string;
  secondaryActionLabel?: string;
  secondaryFilled?: boolean;
  thirdActionLabel?: string;
  fourthActionLabel?: string;
  onCancel?: () => void;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  onThirdClick?: () => void;
  onFourthClick?: () => void;
  disableCancel?: boolean;
  disablePrimary?: boolean;
  disabledPrimaryHoverText?: string;
  disableSecondary?: boolean;
  disableThird?: boolean;
  disableFourth?: boolean;
  cancelDataQa?: string;
  primaryActionDataQa?: string;
  secondaryActionDataQa?: string;
  thirdActionDataQa?: string;
  fourthActionDataQa?: string;
  accordionView?: boolean;
  primaryButtonLoader?: boolean;
  secondButtonLoader?: boolean;
  thirdButtonLoader?: boolean;
  fourthButtonLoader?: boolean;
  hideCancel?: boolean;
  showFullWidth?: boolean;
}

const BottomAppBar = ({
  showPrimary = true,
  omitPrimaryBorder = false,
  cancelLabel = 'Cancel',
  primaryActionLabel = '',
  secondaryActionLabel = '',
  onCancel,
  onPrimaryClick,
  onSecondaryClick,
  secondaryFilled,
  disableCancel,
  disablePrimary,
  disabledPrimaryHoverText = '',
  disableSecondary,
  disableThird,
  disableFourth,
  cancelDataQa = '',
  primaryActionDataQa = '',
  secondaryActionDataQa = '',
  primaryButtonLoader = false,
  secondButtonLoader = false,
  thirdButtonLoader = false,
  fourthButtonLoader = false,
  accordionView,
  thirdActionDataQa,
  thirdActionLabel,
  onThirdClick,
  fourthActionDataQa,
  fourthActionLabel,
  onFourthClick,
  hideCancel,
  showFullWidth,
}: BottomAppBarProps): JSX.Element => {
  const { menuCollapsed } = useViewState();
  const [drawerWidth, setDrawerWidth] = React.useState(menuCollapsed ? 73 : 309);
  React.useEffect(() => {
    if (showFullWidth) {
      setDrawerWidth(45);
    } else {
      setDrawerWidth(menuCollapsed ? 72 : 311);
    }
  }, [menuCollapsed]);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      footerWrap: {
        position: 'fixed',
        bottom: 0,
        background: '#E7F1FA',
        borderTop: `1px solid`,
        borderColor: theme.palette.divider,
        width: `calc(100% - ${drawerWidth}px)`,
        padding: `9.5px 24px`,
        display: 'flex',
        justifyContent: 'space-between',
        zIndex: 11,
        left: `${drawerWidth}px`,
      },
      hideCancelView: {
        justifyContent: 'flex-end',
      },
      footerActions: {
        '& .MuiButton-root': {
          marginLeft: theme.spacing(2),
        },
      },
      accordionView: {
        left: menuCollapsed ? '72px' : '311px',
      },
      primaryAction: {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    }),
  );
  const primaryButton = () => {
    return (
      <AgentNetButton
        variant="contained"
        color="primary"
        onClick={onPrimaryClick}
        data-testid={primaryActionDataQa}
        disabled={disablePrimary}
        {...(primaryButtonLoader ? { loading: primaryButtonLoader } : {})}
        size="small"
        className={omitPrimaryBorder ? undefined : classes.primaryAction}
      >
        {primaryActionLabel}
      </AgentNetButton>
    );
  };
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.footerWrap, {
        [classes.accordionView]: accordionView === true,
        [classes.hideCancelView]: hideCancel,
      })}
    >
      {!hideCancel && (
        <AgentNetButton
          variant="outlined"
          color="primary"
          onClick={onCancel}
          disabled={disableCancel}
          data-testid={cancelDataQa}
          size="small"
        >
          {cancelLabel}
        </AgentNetButton>
      )}
      <div className={classes.footerActions}>
        {fourthActionLabel && (
          <AgentNetButton
            variant="outlined"
            color="primary"
            onClick={onFourthClick}
            data-testid={fourthActionDataQa}
            disabled={disableFourth}
            {...(fourthButtonLoader ? { loading: fourthButtonLoader } : {})}
            size="small"
          >
            {fourthActionLabel}
          </AgentNetButton>
        )}
        {thirdActionLabel && (
          <AgentNetButton
            variant="outlined"
            color="primary"
            onClick={onThirdClick}
            data-testid={thirdActionDataQa}
            disabled={disableThird}
            {...(thirdButtonLoader ? { loading: thirdButtonLoader } : {})}
            size="small"
          >
            {thirdActionLabel}
          </AgentNetButton>
        )}
        {secondaryActionLabel && (
          <AgentNetButton
            variant={secondaryFilled ? 'contained' : 'outlined'}
            onClick={onSecondaryClick}
            data-testid={secondaryActionDataQa}
            disabled={disableSecondary}
            {...(secondButtonLoader ? { loading: secondButtonLoader } : {})}
            color="primary"
            size="small"
          >
            {secondaryActionLabel}
          </AgentNetButton>
        )}
        {primaryActionLabel && showPrimary && (
          <Tooltip title={disablePrimary ? disabledPrimaryHoverText : ''} arrow placement="top">
            <span style={{ display: 'inline-block' }}>{primaryButton()}</span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default BottomAppBar;
